import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa6';
import Logo from '../common/Logo';
import { WHATSAPP_LINK, SOCIAL } from '../../utils/constants';
import { SocialBar } from '../common/SocialIcons';

const PAGES = [
  { name: 'Home', path: '/' },
  { name: 'Books', path: '/books' },
  { name: 'Poets', path: '/poets' },
  { name: 'Articles', path: '/articles' },
  { name: 'Gallery', path: '/gallery' },
  { name: 'News & Events', path: '/news' },
  { name: 'Contact', path: '/contact' },
];

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => setMobileOpen(false), [location]);

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, padding: '0 40px', height: scrolled ? 64 : 72,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        background: 'rgba(255,252,247,.88)', backdropFilter: 'blur(16px)',
        borderBottom: '1px solid rgba(232,133,26,.08)', transition: 'all .35s',
        boxShadow: scrolled ? '0 4px 30px rgba(232,133,26,.1)' : 'none',
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Logo size={70} />
          <span className="serif" style={{ fontSize: '2rem', fontWeight: 700, color: 'var(--dark)' }}>Wijjdan</span>
        </Link>

        {/* Desktop */}
        <div style={{ display: 'flex', gap: 4, alignItems: 'center' }} className="nav-desktop">
          {PAGES.map(p => (
            <Link key={p.path} to={p.path} style={{
              fontSize: 17, fontWeight: location.pathname === p.path ? 600 : 500,
              color: location.pathname === p.path ? 'var(--saffron)' : 'var(--brown)',
              padding: '8px 13px', borderRadius: 8, transition: 'all .2s', position: 'relative',
            }}>
              {p.name}
              {location.pathname === p.path && <span style={{ position: 'absolute', bottom: 2, left: '50%', transform: 'translateX(-50%)', width: 16, height: 3, borderRadius: 2, background: 'var(--saffron)' }} />}
            </Link>
          ))}
          <a href={SOCIAL.youtube + '/live'} target="_blank" rel="noopener noreferrer" style={{
            display: 'inline-flex', alignItems: 'center', gap: 6, background: '#DC2626', color: 'white',
            borderRadius: 20, fontWeight: 600, padding: '8px 18px', fontSize: 13,
          }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'white', animation: 'livePulse 1.5s infinite', display: 'inline-block' }} /> LIVE
          </a>
        </div>

        <button onClick={() => setMobileOpen(true)} className="nav-mobile-btn" style={{ display: 'none', background: 'none', border: 'none', cursor: 'pointer', fontSize: 24, color: 'var(--dark)' }}>☰</button>
      </nav>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 200, background: 'rgba(0,0,0,.4)' }} onClick={() => setMobileOpen(false)}>
          <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: 280, background: 'var(--warm-white)', padding: 24, animation: 'slideIn .25s ease' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <span className="serif" style={{ fontSize: '1.3rem', fontWeight: 1000 }}>Wijjdan</span>
              <button onClick={() => setMobileOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 24 }}>✕</button>
            </div>
            {PAGES.map(p => (
              <Link key={p.path} to={p.path} style={{ display: 'block', padding: '14px 16px', borderRadius: 10, fontSize: 16, color: 'var(--brown)', marginBottom: 2 }}>{p.name}</Link>
            ))}
            <a href={SOCIAL.youtube + '/live'} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 12, background: '#DC2626', color: 'white', borderRadius: 20, padding: '10px 20px', fontWeight: 600 }}>LIVE</a>
            <div style={{ marginTop: 20 }}><SocialBar /></div>
          </div>
        </div>
      )}

      <style>{`
        @media(max-width:768px) { .nav-desktop { display: none !important; } .nav-mobile-btn { display: block !important; } nav { padding: 0 16px !important; } }
        @keyframes slideIn { from{transform:translateX(100%)} to{transform:translateX(0)} }
      `}</style>
    </>
  );
}

export function WhatsAppFloat() {
  return (
    <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" style={{
      position: 'fixed', bottom: 28, right: 28, zIndex: 999, width: 60, height: 60, borderRadius: '50%',
      background: '#25D366', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center',
      boxShadow: '0 4px 20px rgba(37,211,102,.4)', transition: 'transform .2s,box-shadow .2s',
    }} title="Chat on WhatsApp">
      <FaWhatsapp size={28} />
    </a>
  );
}
